import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const StoreContext = createContext(null);

export const StoreProvider = ({ children }) => {
  const [config, setConfig] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/config");
      setConfig(data);
    } catch {
      setConfig({ store_open: false });
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const storeOpen = config ? !!config.store_open : true; // optimistic until loaded

  return (
    <StoreContext.Provider value={{ config, storeOpen, refresh }}>
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => useContext(StoreContext);
